import '@/app/app.css';
import './product.css';

import '@/app/app';
import '@/layouts/main/main';

import { ProductImages } from './sections/product-images/product-images';
import { ModalGallery } from '@/features/modal/modal-gallery/modal-gallery';
import { ProductCode } from '@/pages/product/sections/product-info/product-code/product-code';
import { ProductShare } from '@/pages/product/sections/product-info/product-share/product-share';
import { SwiperCarousel } from '@/shared/swiper/swiper-carousel/swiper-carousel.js';
import { vars } from '@/app/config/variables.js';
import { ProductFixed } from '@/pages/product/sections/product-fixed/product-fixed';
import { productFavourite } from './sections/product-info/product-like/product-like';
import { productAdd } from './sections/product-add/product-add.js';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-product-images').forEach((element) => new ProductImages(element));
	new ProductCode(document.querySelector('.product-code'));
	new ProductShare(document.querySelector('.product-share'));
	new ModalGallery();
	window.app.test = new ProductFixed(document.querySelector('.js-product-fixed'));
	productFavourite();
	productAdd(document.querySelector('.product-layout'));

	document.querySelectorAll('.js-product-reviews').forEach((element) => {
		new SwiperCarousel(element, {
			[vars.breakpoint.tablet]: {
				slidesPerView: 3,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 8,
			},
			[vars.breakpoint.laptop]: {
				slidesPerView: 4,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				spaceBetween: 16,
			},
		});
	});

	if (window.BX.mock) {
		const form = app.classInstance.get(document.querySelector('.product-form')).form;
		form.addCallbacks({
			onSubmit: () => new Promise((resolve) => {
				window.app.modal.open('#product-form-result');
				resolve();
			}),
		});
	}
});
